
const SET_NEW_SERVICE = () => {
  return 
}
const SET_CLOSED_SERVICE = () => {
  return
}
const SET_SERVICES = (state, payload) => {
  state.services = payload;
}
const SET_PAGINATION = (state, payload) => {
  state.pagination = payload;
}
const SET_SINGLE_SERVICE = (state, payload) => {
  state.service_single = payload;
}
const SET_LAST_SERVICE = (state, payload) => {
  state.last_service = payload;
}
const DELETE_SERVICE = (state, payload) => {
  const index = state.services.findIndex(service => service.id === payload.id);
  state.services.splice(index, 1);
}
const SET_LABS = (state, payload) => {
  state.labs = payload;
}

export default {
  SET_NEW_SERVICE,
  SET_SERVICES,
  SET_PAGINATION,
  SET_SINGLE_SERVICE,
  SET_CLOSED_SERVICE,
  SET_LAST_SERVICE,
  DELETE_SERVICE,
  SET_LABS
}